import { pathSeperatorRegex } from './common.js';
export function get(root, path, defaultValue) {
    try {
        if (root.toObject)
            root = root.toObject();
        if (Array.isArray(path))
            path = "['" + path.join("']['") + "']";
        if (path in root || typeof path === 'number')
            return root[path];
        let obj = root;
        path.replace(pathSeperatorRegex, (whole, _quotationMark, quotedProp, namedProp, index) => {
            obj = obj[quotedProp || namedProp || index];
            return whole;
        });
        return obj !== null && obj !== void 0 ? obj : defaultValue;
    }
    catch (err) {
        return defaultValue;
    }
}
/**
 * @deprecated use get()
 */
export const dotprop = get;
